var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCreateDebate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 0.7,
    width: 42.6,
    height: 42.6,
    rx: 21.3,
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 0.7,
    width: 42.6,
    height: 42.6,
    rx: 21.3,
    stroke: "black",
    strokeWidth: 1.4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 22C30.5 22.1768 30.4298 22.3464 30.3047 22.4714C30.1797 22.5964 30.0101 22.6667 29.8333 22.6667H23.1667V29.3333C23.1667 29.5101 23.0964 29.6797 22.9714 29.8047C22.8464 29.9298 22.6768 30 22.5 30C22.3232 30 22.1536 29.9298 22.0286 29.8047C21.9036 29.6797 21.8333 29.5101 21.8333 29.3333V22.6667H15.1667C14.9899 22.6667 14.8203 22.5964 14.6953 22.4714C14.5702 22.3464 14.5 22.1768 14.5 22C14.5 21.8232 14.5702 21.6536 14.6953 21.5286C14.8203 21.4036 14.9899 21.3333 15.1667 21.3333H21.8333V14.6667C21.8333 14.4899 21.9036 14.3203 22.0286 14.1953C22.1536 14.0702 22.3232 14 22.5 14C22.6768 14 22.8464 14.0702 22.9714 14.1953C23.0964 14.3203 23.1667 14.4899 23.1667 14.6667V21.3333H29.8333C30.0101 21.3333 30.1797 21.4036 30.3047 21.5286C30.4298 21.6536 30.5 21.8232 30.5 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreateDebate);
export default __webpack_public_path__ + "static/media/icon-create-debate.ed99e45efd47ca56b5b3b4562187a8bf.svg";
export { ForwardRef as ReactComponent };